var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60002 2.60039C5.73403 2.60039 2.60002 5.7344 2.60002 9.60039C2.60002 13.4664 5.73403 16.6004 9.60002 16.6004C13.466 16.6004 16.6 13.4664 16.6 9.60039C16.6 5.7344 13.466 2.60039 9.60002 2.60039ZM1.40002 9.60039C1.40002 5.07166 5.07129 1.40039 9.60002 1.40039C14.1288 1.40039 17.8 5.07166 17.8 9.60039C17.8 14.1291 14.1288 17.8004 9.60002 17.8004C5.07129 17.8004 1.40002 14.1291 1.40002 9.60039ZM15.9758 15.9761C16.2101 15.7418 16.59 15.7418 16.8243 15.9761L18.4243 17.5761C18.6586 17.8104 18.6586 18.1903 18.4243 18.4247C18.19 18.659 17.8101 18.659 17.5758 18.4247L15.9758 16.8247C15.7414 16.5903 15.7414 16.2104 15.9758 15.9761Z",
    fill: "#868381"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Search.ce5e1402.svg";
export { ForwardRef as ReactComponent };